module.exports = __webpack_public_path__ + "img/member_deals_card_image6.c0bdb82b.png";